import VideoFullwidth from '../components/videoFullwidth'

class VideoFullwidths {
	private components: VideoFullwidth[] = []

	init( container: Document | HTMLElement = document ) {
		container.querySelectorAll<HTMLElement>( '.hg-video-fullwidth' ).forEach( ( el ) => {
			const c = new VideoFullwidth( el )
			c.init()
			this.components.push( c )
		} )
	}

	update( container: Document | HTMLElement = document ) {
		this.cleanup()
		this.init( container )
	}

	cleanup() {
		this.components.forEach( ( c ) => c.cleanup() )
		this.components = []
	}
}

export default new VideoFullwidths()
